import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import CheckBox from '~/Common-Objects/UI/Forms/CheckBox/CheckBox'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextArea from '~/Common-Objects/UI/Forms/TextArea/TextArea'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import axios from '~/data/http/axios'
import { alterSiteDrawer } from '../../../data/actions/siteActions'

export default function LabQuestions({ lab, onClose = () => { } }) {
    const dispatch = useDispatch()
    const [answers, setAnswers] = useState([])
    const [errors, setErrors] = useState({})
    const [finishing, setFinishing] = useState(false)

    const updateValue = (value, label, other = false) => {
        const answer = answers.find(a => a.question === label)
        const question = lab.questions.find(q => q.label === label)
        if (answer) {
            if (question.type === 'select' && question.multi && !other) {
                const arr = [...answer.answer]
                if (arr.indexOf(value) === -1) {
                    arr.push(value)
                } else {
                    arr.splice(arr.indexOf(value), 1)
                }
                value = arr
            }
            answer[other ? 'other' : 'answer'] = value
            setAnswers([...answers])
        } else {
            if (question.type === 'select' && question.multi) {
                value = [value]
            }
            setAnswers([...answers, { question: label, [other ? 'other' : 'answer']: value }])
        }
    }

    const finish = async () => {
        // validate
        const errs = {}
        setFinishing(true)
        for (const q of lab.questions) {
            const answer = answers.find(a => a.question === q.label)
            if (q.required && (!answer || answer.answer === '')) {
                errs[q.label] = 'required'
            }
            if (q.required && q.other && answer) {
                if (Array.isArray(answer.answer)) {
                    if (answer.answer.includes('other') && !answer.other) {
                        errs[q.label + '_other'] = 'required'
                    }
                } else if (answer.answer === 'other' && !answer.other) {
                    errs[q.label + '_other'] = 'required'
                }
            }
            if (q.type === 'boolean' && answer?.answer === false) {
                errs[q.label] = 'required'
            }
        }
        if (Object.keys(errs).length) {
            setErrors(errs)
            setFinishing(false)
            return
        }
        await axios.post('/accountMaster/labs/' + lab.id, {
            answers
        })
        setErrors({})
        setFinishing(false)
        cancel()
    }

    const cancel = () => {
        onClose()
        dispatch(alterSiteDrawer(false, true, 'right', null, true, 500))
    }

    return (
        <div>
            <h4 className={lab.closedBetaDescription ? 'mar-b5' : "mar-b20"}>Enable {lab.fullName} for your Account</h4>
            {!!lab.closedBetaDescription && <div className="text-grey mar-b20">{lab.closedBetaDescription}</div>}
            {lab.questions.map((q, i) => {
                const answer = answers.find(a => a.question === q.label)
                if (q.type === 'string') {
                    return <TextInput error={errors[q.label]} outerClassName="mar-b20" key={i} label={q.label} placeholder={q.placeholder} value={answer?.answer || ""} onChange={e => updateValue(e.currentTarget.value, q.label)} />
                }
                if (q.type === 'number') {
                    return <TextInput error={errors[q.label]} outerClassName="mar-b20" key={i} type="number" label={q.label} placeholder={q.placeholder} value={answer?.answer || ""} onChange={e => updateValue(e.currentTarget.value, q.label)} />
                }
                if (q.type === 'select') {
                    let showOther = false
                    if (q.other && answer) {
                        if (Array.isArray(answer.answer)) {
                            if (answer.answer.includes('other')) {
                                showOther = true
                            }
                        } else {
                            if (answer.answer === 'other') {
                                showOther = true
                            }
                        }
                    }
                    return <div key={i} className="mar-b20">
                        <Select hideplaceholder={true} error={errors[q.label]} multiple={q.multi} label={q.label} placeholder={q.placeholder} value={answer?.answer || ""} onChange={e => updateValue(e.currentTarget.value, q.label)} data={q.options} />
                        {showOther && <TextArea placeholder="Other Details" error={errors[q.label + '_other']} outerClassName="mar-t10" value={answer?.other} onChange={e => updateValue(e.currentTarget.value, q.label, true)} rows="3" />}
                    </div>
                }
                if (q.type === 'boolean') {
                    const textColor = errors[q.label] ? 'text-red' : ''
                    return <div className="mar-b20">
                        <CheckBox error={errors[q.label]} outerClassName="mar-b20" checked={answer?.answer} onChange={e => updateValue(e.currentTarget.checked, q.label)}>
                            {!q.text && <div className={textColor}>{q.label}</div>}
                            {!!q.text && <div className={textColor} dangerouslySetInnerHTML={{ __html: q.text }}></div>}
                        </CheckBox>
                    </div>
                }

            })}
            <div className="quickFlex" style={{ gap: 8 }}>
                <Button className="button-primary" onClick={finish} disabled={finishing} iconRight={finishing && <Icons icon="loading" />}>Enable and Close</Button>
                <Button onClick={cancel}>Close</Button>
            </div>
        </div>
    )
}